import login       from '@/pages/login/memberLogin'
import myPage   from '@/pages/login/myPage'
import join       from '@/pages/login/join'
import orgJoin       from '@/pages/login/orgJoin'
import joinType       from '@/pages/login/joinType'
import findID       from '@/pages/login/findID'
import findPW       from '@/pages/login/findPW'
export default [
    {
        path: '/join',
        name: 'join',
        component: join,
    },
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path: '/orgJoin',
        name: 'orgJoin',
        component: orgJoin,
    },
    {
        path: '/myPage',
        name: 'myPage',
        component: myPage,
    },
    {
        path: '/joinType',
        name: 'joinType',
        component: joinType,
    },
    {
        path: '/findID',
        name: 'findID',
        component: findID,
    },
    {
        path: '/findPW',
        name: 'findPW',
        component: findPW,
    }
]
